export const formContent = {
    heading: 'Add event',
    personName: {
        id: 'personName',
        label: 'Person name (Organiser)',
        validation: {
            required: "Organiser is required"
        }
    },
    eventName: {
        id: 'eventName',
        label: 'Event name',
        validation: {
            required: "Event name is required"
        }
    },
    eventDescription: {
        id: 'description',
        label: 'Event description',
        validation: {
            required: "Event description is required"
        }
    },
    eventType: {
        id: 'eventTypeId',
        label: 'Event type',
        validation: {
            required: "Select event type"
        }
    },
    eventBudget: {
        id: 'Budget',
        label: 'Event budget amount($)',
        type: 'number',
        validation: {
            required: "Event budget is required"
        }
    },
    eventDate: {
        id: 'eventDate',
        label: 'Event date',
        type: 'date',
        validation: {
            required: "Event date is required"
        }
    },
    eventStartTime: {
        id: 'eventTime',
        label: 'Event start time',
        type: 'time',
        validation: {
            required: "Event start time is required"
        }
    },
    noEndTime: {
        id: 'noEndTime',
        label: 'Check if no end time',
        type: 'checkbox'
    },
    eventEndTime: {
        id: 'eventEndTime',
        label: 'Event end time',
        type: 'time'
    },
    rsvpDate: {
        id: 'rsvpDate',
        label: 'RSVP date',
        type: 'date',
        validation: {
            required: "RSVP date is required"
        }
    },
    eventAddress: {
        id: 'address',
        label: 'Event address',
        validation: {
            required: "Event address is required"
        },
        addressType:'address'
    },
    state: {
        id: 'state',
        type: 'hidden'
    },
    latitude: {
        id: 'latitude',
        type: 'hidden'
    },
    longitude: {
        id: 'longitude',
        type: 'hidden'
    },
    eventImages: {
        id: 'eventImages',
        label: 'Event images'
    },
    addEventButton: {
        id: 'addEventButton',
        label: 'Add event',
        type: 'submit'
    }
}
